(function () {
  function closeAllPickers() {
    document.querySelectorAll('.sc-variant-popover').forEach(function (p) { p.hidden = true; });
    document.querySelectorAll('.sc-choose-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  function addToCart(variantId, pill) {
    var originalText = pill.textContent;
    pill.textContent = 'Adding\u2026';
    pill.style.pointerEvents = 'none';

    var cartNotification = document.querySelector('cart-notification');
    var sectionsParam = cartNotification
      ? cartNotification.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    var body = { id: parseInt(variantId, 10), quantity: 1 };
    if (sectionsParam.length) {
      body.sections = sectionsParam;
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (cartNotification && data.sections) cartNotification.renderContents(data);
        pill.textContent = '\u2713 Added!';
        pill.style.background = '#2a7a3b';
        pill.style.borderColor = '#2a7a3b';
        setTimeout(function () {
          pill.textContent = originalText;
          pill.style.background = '';
          pill.style.borderColor = '';
          pill.style.pointerEvents = '';
          closeAllPickers();
        }, 1800);
      })
      .catch(function () {
        pill.textContent = originalText;
        pill.style.pointerEvents = '';
      });
  }

  function updateCardPrice(radio) {
    var price = radio.getAttribute('data-price');
    var compare = radio.getAttribute('data-compare');
    if (!price) return;
    var picker = radio.closest('.sc-variant-picker');
    if (!picker) return;
    var card = picker.closest('.productBox, .grid-col, .card-wrapper, [class*="card"]');
    if (!card) return;
    var priceEl = card.querySelector('.money[data-product-id], h5, .price__regular, .price-item--regular');
    if (!priceEl) return;
    var compareHtml = (compare && compare !== '$0.00') ? ' <small style="text-decoration:line-through;color:#999;">' + compare + '</small>' : '';
    priceEl.innerHTML = '<strong style="color:#E8621A;">' + price + '</strong>' + compareHtml;
  }

  document.addEventListener('click', function (e) {
    var chooseBtn = e.target.closest('.sc-choose-btn');
    var pill = e.target.closest('.sc-variant-option:not(.sc-variant-option--oos) span');

    if (chooseBtn) {
      e.stopPropagation();
      var wrapper = chooseBtn.closest('.sc-variant-picker');
      if (!wrapper) return;
      var popover = wrapper.querySelector('.sc-variant-popover');
      var isOpen = chooseBtn.getAttribute('aria-expanded') === 'true';
      closeAllPickers();
      if (!isOpen) {
        chooseBtn.setAttribute('aria-expanded', 'true');
        popover.hidden = false;
      }
      return;
    }

    if (pill) {
      e.stopPropagation();
      var label = pill.closest('.sc-variant-option');
      if (!label) return;
      var radio = label.querySelector('input[type="radio"]');
      if (radio && !radio.disabled) {
        updateCardPrice(radio);
        addToCart(radio.value, pill);
      }
      return;
    }

    if (!e.target.closest('.sc-variant-picker')) {
      closeAllPickers();
    }
  });
})();
